/* Products.tsx
	Page affichant la gestion des produits
	Utilise ProductsCrudCard pour bénéficier de la pagination, du tri et des filtres côté serveur
*/

// Import FontAwesome
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

// Import Feature
import { ProductsCrudCard } from 'features/products';

// Import Layout
import PageHeader from 'layout/PageHeader';

export const Products = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faLayerGroup}
			title="Produits"
			subtitle="Gérez le catalogue de produits"
		/>
		<ProductsCrudCard
			size="lg"
			returnPath="/app/settings"
			returnLabel="Paramètres"
			className="mt-6"
		/>
	</div>
);
